import PropTypes from 'prop-types';
import { ChevronRight, CheckCircle } from "lucide-react";

const MenuList = ({ menus, selectedMenu, onMenuSelect }) => {
    const handleMenuClick = (menuId, menuName) => {
        localStorage.setItem('selectedMenu', menuId);
        localStorage.setItem('selectedMenuName', menuName);
        onMenuSelect(menuId);

        // Dispatch custom event om Header te updaten
        window.dispatchEvent(new Event('menuChanged'));
    };

    return (
        <div className="mb-8 mt-[50px] overflow-y-auto max-h-[50vh]">
            <h2 className="text-xl font-normal mb-4 font-inter text-ps-blue-dark">Menukaarten</h2>
            <div className="space-y-2">
                {menus.map((menu) => (
                    <div
                        key={menu.id}
                        className="flex items-center justify-between w-full p-4 hover:pl-6 cursor-pointer border-b-[1px]"
                        onClick={() => handleMenuClick(menu.id, menu.name)}
                    >
                        <div className="flex items-center gap-3">
                            <CheckCircle
                                className={selectedMenu === menu.id ? 'text-green-600' : 'text-gray-400'}
                                size={20}
                            />
                            <span className="font-inter">{menu.name}</span>
                        </div>
                        <ChevronRight className="text-ps-blue-dark" size={20} />
                    </div>
                ))}
            </div>
        </div>
    );
};

MenuList.propTypes = {
    menus: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
        })
    ).isRequired,
    selectedMenu: PropTypes.number,
    onMenuSelect: PropTypes.func.isRequired,
};

export default MenuList;